import { gql } from '@apollo/client';

import { COMPANY_FIELDS, VACANCY_FIELDS } from './fields';

export const GET_COMPANY_BY_ID = gql`
  ${VACANCY_FIELDS}
  ${COMPANY_FIELDS}
  query Company($id: ID!) {
    company(id: $id) {
      ...companyFields
      publishedCount
      regionId
      regionName
      specializationName
      ads {
        ...vacancyFields
      }
    }
  }
`;
